import { useState, useEffect } from 'react'

const NAV_ITEMS = [
  { label: 'TOP', href: '#top', sectionId: 'top' },
  { label: '当社の特徴', href: '#features', sectionId: 'features' },
  { label: '開発分野', href: '#development', sectionId: 'development' },
  { label: '開発実績', href: '#achievements', sectionId: 'achievements' },
  { label: '技術者募集', href: '#recruitment', sectionId: 'recruitment' },
  { label: '会社概要', href: '#company', sectionId: 'company' },
  { label: 'アクセス', href: '#access', sectionId: 'access' },
  { label: '主要取引先', href: '#partners', sectionId: 'partners' }
]

export function Header() {
  const [scrolled, setScrolled] = useState(false)
  const [menuOpen, setMenuOpen] = useState(false)
  const [activeSection, setActiveSection] = useState('top')

  useEffect(() => {
    const onScroll = () => {
      setScrolled(window.scrollY > 50)

      // アクティブセクションの検出
      const sections = NAV_ITEMS.map((item) =>
        document.getElementById(item.sectionId)
      )
      const scrollMid = window.scrollY + window.innerHeight / 3

      for (let i = sections.length - 1; i >= 0; i--) {
        const el = sections[i]
        if (el && el.offsetTop <= scrollMid) {
          setActiveSection(NAV_ITEMS[i].sectionId)
          break
        }
      }
    }
    window.addEventListener('scroll', onScroll, { passive: true })
    return () => window.removeEventListener('scroll', onScroll)
  }, [])

  return (
    <header
      className={`fixed top-0 left-0 right-0 z-50 transition-all duration-300 rounded-b-xl  ${
        scrolled
          ? 'bg-white/50 backdrop-blur-xl shadow-sm border-b border-slate-200/60'
          : 'bg-white/80 backdrop-blur-sm'
      }`}
    >
      <div
        className={`max-w-7xl mx-auto px-6 flex items-center justify-between transition-all duration-300 ${
          scrolled ? 'h-14 md:h-16' : 'h-16 md:h-20'
        }`}
      >
        {/* ロゴ */}
        <a href="#top" className="flex items-center gap-3 shrink-0">
          <img
            src="/images/JF_logo_01.png"
            alt="J-Frontier"
            className={`w-auto rounded object-cover transition-all duration-300 ${
              scrolled ? 'h-8 md:h-9' : 'h-10 md:h-12'
            }`}
          />
        </a>

        {/* PCナビ */}
        <nav className="hidden lg:flex items-center gap-1">
          {NAV_ITEMS.map((item) => {
            const isActive = activeSection === item.sectionId
            return (
              <a
                key={item.href}
                href={item.href}
                className={`relative px-3 py-2 text-sm font-medium whitespace-nowrap transition-colors duration-200 group ${
                  isActive
                    ? 'text-brand-blue'
                    : 'text-brand-navy/60 hover:text-brand-navy'
                }`}
              >
                {item.label}
                {/* シアンアンダーライン */}
                <span
                  className={`absolute bottom-0 left-1/2 -translate-x-1/2 h-0.5 bg-brand-cyan rounded-full transition-all duration-300 ${
                    isActive ? 'w-4/5' : 'w-0 group-hover:w-4/5'
                  }`}
                />
              </a>
            )
          })}
        </nav>

        {/* お問い合わせ CTA */}
        <a
          href="#contact"
          className="hidden lg:inline-flex items-center gap-1.5 px-4 py-2 rounded-full border border-slate-300 text-brand-navy/60 text-sm font-medium
            hover:border-brand-cyan hover:text-brand-blue transition-all duration-200 shrink-0"
        >
          <svg
            className="w-3.5 h-3.5"
            fill="none"
            stroke="currentColor"
            strokeWidth={2.5}
            viewBox="0 0 24 24"
          >
            <path
              strokeLinecap="round"
              strokeLinejoin="round"
              d="M21.75 6.75v10.5a2.25 2.25 0 01-2.25 2.25h-15a2.25 2.25 0 01-2.25-2.25V6.75m19.5 0A2.25 2.25 0 0019.5 4.5h-15a2.25 2.25 0 00-2.25 2.25m19.5 0v.243a2.25 2.25 0 01-1.07 1.916l-7.5 4.615a2.25 2.25 0 01-2.36 0L3.32 8.91a2.25 2.25 0 01-1.07-1.916V6.75"
            />
          </svg>
          お問い合わせ
        </a>

        {/* ハンバーガー */}
        <button
          className="lg:hidden p-2 text-brand-navy"
          onClick={() => setMenuOpen(!menuOpen)}
          aria-label="メニュー"
        >
          <span
            className={`block w-5 h-0.5 bg-brand-navy transition-all duration-300 ${menuOpen ? 'rotate-45 translate-y-[7px]' : ''}`}
          />
          <span
            className={`block w-5 h-0.5 bg-brand-navy mt-1.5 transition-all duration-300 ${menuOpen ? 'opacity-0 scale-x-0' : ''}`}
          />
          <span
            className={`block w-5 h-0.5 bg-brand-navy mt-1.5 transition-all duration-300 ${menuOpen ? '-rotate-45 -translate-y-[7px]' : ''}`}
          />
        </button>
      </div>

      {/* モバイルメニュー（スライドダウン） */}
      <div
        className={`lg:hidden overflow-hidden transition-all duration-300 ease-in-out ${
          menuOpen ? 'max-h-[520px] opacity-100' : 'max-h-0 opacity-0'
        }`}
      >
        <div className="bg-white/95 backdrop-blur-md border-t border-slate-100 pb-2">
          {NAV_ITEMS.map((item) => {
            const isActive = activeSection === item.sectionId
            return (
              <a
                key={item.href}
                href={item.href}
                className={`flex items-center gap-3 px-6 py-3.5 text-sm font-medium border-b border-slate-50 transition-colors ${
                  isActive
                    ? 'text-brand-blue bg-slate-50'
                    : 'text-brand-navy/70 hover:text-brand-blue hover:bg-slate-50'
                }`}
                onClick={() => setMenuOpen(false)}
              >
                {isActive && (
                  <span className="w-1 h-4 rounded-full bg-brand-cyan shrink-0" />
                )}
                {item.label}
              </a>
            )
          })}
          <div className="px-6 pt-3 pb-2">
            <a
              href="#contact"
              className="flex items-center justify-center gap-2 w-full py-3 rounded-xl bg-brand-blue text-white text-sm font-semibold
                hover:bg-brand-navyLight transition-colors"
              onClick={() => setMenuOpen(false)}
            >
              お問い合わせ
            </a>
          </div>
        </div>
      </div>
    </header>
  )
}
